import { Drawer } from "antd";
import { apiHost } from "consts";
import CardSample from "features/cases/blocks/CommonCard";
import { useIsMobile } from "hooks/useIsMobile";
import { useTexts } from "hooks/useTexts";
import { useUser } from "hooks/useUser";
import React from "react";

type ProblemDrawerProps = {
  problemId: string;
  problem: any;
  isOpen: boolean;
  onClose: () => void;
};

const ProblemDrawer: React.FC<ProblemDrawerProps> = ({
  problemId,
  problem,
  isOpen,
  onClose,
}) => {
  const { isMobile } = useIsMobile();
  const { txt } = useTexts("case");
  const { isContributor } = useUser();

  return (
    <Drawer
      width={isMobile ? "100%" : "400px"}
      title={txt("problem", "Проблема")}
      closable={{ "aria-label": "Закрыть" }}
      onClose={onClose}
      open={isOpen}
    >
      <h3>{txt("problem", "Проблема")}</h3>
      <CardSample
        parentData={{
          isProblem: true,
          sphereId: problem?.sphere,
          isSolution: false,
          isAttribute: false,
          problemId,
        }}
        cardContentId={problemId}
        sectionTitle={txt("problem", "Проблема")}
        objectColor="#FFF2CB"
        highlightColor="#fcd757"
        mode="wide"
        key="top"
        meta={problem?.meta}
        title={problem?.title}
        description={problem?.description}
        url={`#/problems/${problemId}/`}
        editUrl={`${apiHost}/admin/solutions/problem/${problemId}/change/`}
        linkButtonText={
          isContributor
            ? txt("more_details", "Подробнее")
            : txt("more_details_problem", "Подробнее о проблеме")
        }
        onLinkClick={onClose}
      />

      <br />
      <br />
    </Drawer>
  );
};

export default ProblemDrawer;
